import router from '@/router'

export default {
  state: {
    projectTitleLink: [],
    detailedProjectTitleLink: []
  },
  mutations: {
    setProjectTitleLink (state, payload) {
      state.projectTitleLink = payload
    },
    setDetailedProjectTitleLink (state, payload) {
      state.detailedProjectTitleLink = payload
    }
  },
  actions: {
    async setProjectTitleLink (ctx, payload) {
      let res = await fetch(`${ctx.getters.getUrlApi}api/project_title_links`)
      res = await res.json()
      this.commit('setProjectTitleLink', await res)
    },

    async setDetailedProjectTitleLink (ctx, payload) {
      let res = await fetch(`${ctx.getters.getUrlApi}api/admin/project_title_links/${payload}`, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      })
      res = await res.json()
      this.commit('setDetailedProjectTitleLink', await res)
    },

    async deleteProjectTitleLink (ctx, payload) {
      await fetch(`${ctx.getters.getUrlApi}api/admin/project_title_links/${payload}`, {
        method: 'DELETE',
        headers: {
          Authorization: localStorage.getItem('token')
        }
      }).then(res => {
        if (res.status === 200) {
          ctx.commit('setMessage', {
            type: 'success',
            text: 'Ссылка успешно удалена'
          })
        } else {
          ctx.commit('setMessage', { type: 'error', text: 'Ошибка удаления' })
        }
        ctx.dispatch('setProjectTitleLink')
      })
        .catch(error => console.log('error', error))
    },

    async createProjectTitleLink (ctx, payload) {
      await fetch(`${ctx.getters.getUrlApi}api/admin/project_title_links`, {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('token')
        },
        body: payload
      })
        .then(res => {
          if (res.status === 201) {
            router.push('/admin/project_title_links')
            ctx.commit('setMessage', {
              type: 'success',
              text: 'Создание ссылки прошло успешно'
            })
          } else {
            ctx.commit('setMessage', {
              type: 'error',
              text: 'Ошибка создания'
            })
          }
        })
        .catch(error => console.log('error', error))
    },

    async editProjectTitleLink (ctx, payload) {
      await fetch(`${ctx.getters.getUrlApi}api/admin/project_title_links/${payload.id}`, {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('token')
        },
        body: payload.data
      })
        .then(res => {
          if (res.status === 200) {
            router.push('/admin/project_title_links')
            ctx.commit('setMessage', {
              type: 'success',
              text: 'Изменение ссылки прошло успешно'
            })
          } else {
            ctx.commit('setMessage', {
              type: 'error',
              text: 'Ошибка изменения'
            })
          }
        })
        .catch(error => console.log('error', error))
    }
  },
  getters: {
    getProjectTitleLink: (s) => s.projectTitleLink,
    getDetailedProjectTitleLink: (s) => s.detailedProjectTitleLink
  }
}
